import * as React from "react";
import axios from "axios";
import apiconfig from "../../../../../config/api-config.js";
import { connect, useDispatch, useSelector } from "react-redux";
import {
  fetchDefaultPlaylist,
  loadLocalPlaylist,
} from "../../../../FlikTraxStore/Actions/userActions";
import { addHiddenTrack } from "../../../../FlikTraxStore/Actions/apiActions";
import { useSnackbar } from "notistack";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Slide from "@mui/material/Slide";
import Fade from "@mui/material/Fade";
import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import PlaylistRemoveIcon from "@mui/icons-material/PlaylistRemove";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const RemoveFromSavedPlaylist = (props) => {
  const [open, setOpen] = React.useState(false);

  const dispatch = useDispatch();

  const [value, setValue] = React.useState(0);

  const [listtitle, setListTitle] = React.useState("");

  const [loading, setLoading] = React.useState(false);

  const hiddenTracks = useSelector((state) =>
    state.api.hiddenTracks === undefined ? [] : state.api.hiddenTracks
  );

  const handleChange = (event) => {
    setValue(event.target.value);
    setListTitle();
  };

  const handleClose = () => {
    setOpen(false);
  };

  const { enqueueSnackbar } = useSnackbar();

  const Notify = (notification) => {
    enqueueSnackbar(notification, { variant: "success" });
  };

  const popFromSavedPlaylist = () => {
    axios({
      baseURL: "https://api.fliktrax.com/userplaylist",
      method: "post",
      auth: {
        username: apiconfig.api.APIUSERNAME,
        password: apiconfig.api.APIPASSWORD,
      },
      data: {
        cmd: "removesaved",
        userid: props.user.user.username,
        track_title: props.trackTitle,
        trackid: props.trackID,
        playlist_title: props.playlistTitle,
      },
      headers: {
        "Content-Type": "application/json",
      },
    }).then((response) => {
      let msg = props.trackTitle + " removed from playlist " + props.playlistTitle ;
      Notify(msg);
      hiddenTracks.push(props.trackID);
      dispatch(addHiddenTrack(hiddenTracks));
      fetchDefaultPlaylist();
      loadLocalPlaylist();
      //console.log(response.data); return;
    });
    props.handleMobileMenuClose();
  };
  const handleClickOpen = () => {
    setOpen(true);
    setLoading(true);
    axios({
      baseURL: "https://api.fliktrax.com/userplaylist",
      method: "post",
      auth: {
        username: apiconfig.api.APIUSERNAME,
        password: apiconfig.api.APIPASSWORD,
      },
      data: {
        cmd: "fetchsaved",
        userid: props.user.user.username,
      },
      headers: {
        "Content-Type": "application/json",
      },
    }).then((response) => {
      setPlaylists(response.data);
      setValue(response.data[0].ID);
      setLoading(false);
    });
  };

  const [playlists, setPlaylists] = React.useState([]);

  //console.log(playlists)

  return (
    <React.Fragment>
      <Tooltip
        TransitionComponent={Fade}
        TransitionProps={{ timeout: 600 }}
        title="Remove From Saved Playlist"
        placement="top"
        arrow
      >
        <IconButton
          onClick={popFromSavedPlaylist}
          sx={{ padding: 1 }}
          size="small"
          aria-label="Remove From Saved Playlist"
          color="success"
        >
          <PlaylistRemoveIcon style={{ color: "yellow" }} />
        </IconButton>
      </Tooltip>
    </React.Fragment>
  );
};

function mapStateToProps(state) {
  return {
    api: state.api,
    user: state.user,
  };
}

export default connect(mapStateToProps, {})(RemoveFromSavedPlaylist);
